import axios from 'axios';

import { ApiServiceError } from '../../hooks/api/useApiService';
import { apiRequest } from '../../libs/ApiRequest/ApiRequest';
import { PostFileUploadResponse } from '../../types/files.types';

export const postUploadFile = async (
  containerId: string,
  file?: File,
  abortController?: AbortController
): Promise<PostFileUploadResponse | undefined> => {
  if (!file) throw new Error('File must be defined');
  const formData = new FormData();
  formData.append('file', file);

  try {
    const response = await apiRequest.post<FormData, PostFileUploadResponse>(
      `/files/container/${containerId}`,
      formData,
      {
        'Content-Type': 'multipart/form-data',
      },
      abortController?.signal
    );

    return response.parsedBody;
  } catch (error) {
    if (axios.isAxiosError(error) && !!error.response?.data) {
      const apiServiceError: ApiServiceError = {
        error,
        message: 'Failed to upload file',
        errorCode: 'error.api.files.general',
      };
      throw apiServiceError;
    }

    throw error;
  }
};
